import styled, { css } from 'styled-components';

export const Wrapper = styled.div`
  ${({ theme }) => css`
    position: relative;
    font-family: ${theme.v3.font.family.brand};
  `}
`;

export const LogoWrapper = styled.div`
  position: absolute;
  top: 32px;
  left: 0;

  @media (max-width: ${({ theme }) => theme.v3.breakpoints.md}) {
    position: static;
    margin-bottom: 32px;
  }
`;

export const LogoRow = styled.div`
  ${({ theme }) => css`
    display: flex;
    flex-direction: row;
    align-items: center;
    gap: ${theme.v3.spacing.nano};
  `}

  svg {
    flex: none;
    width: 100%;
    height: 100%;
  }
`;

export const BetaBadge = styled.span`
  ${({ theme }) => css`
    display: inline-flex;
    align-items: center;
    justify-content: center;
    padding: ${theme.v3.spacing.quarck} ${theme.v3.spacing.nano};
    border-radius: 9999px;
    background-color: ${theme.v3.colors.accent.pink[95]};
    flex-shrink: 0;
  `}
`;

export const BetaBadgeText = styled.span`
  ${({ theme }) => css`
    font-family: ${theme.v3.font.family.brand};
    font-size: ${theme.v3.font.sizes.mini};
    font-weight: ${theme.v3.font.weights.medium};
    line-height: ${theme.v3.font.lineHeight.comfortable};
    letter-spacing: 0;
    background: linear-gradient(
      90deg,
      ${theme.v3.colors.brand.snappyOrange[50]} 0%,
      ${theme.v3.colors.accent.pink[50]} 100%
    );
    -webkit-background-clip: text;
    background-clip: text;
    -webkit-text-fill-color: transparent;
  `}
`;

export const Content = styled.div`
  ${({ theme }) => css`
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    gap: ${theme.v3.spacing.xxs};
    padding-top: 80px;

    @media (max-width: ${theme.v3.breakpoints.md}) {
      flex-direction: column;
      align-items: flex-start;
      padding-top: 0;
    }
  `}
`;

export const LeftSide = styled.div`
  ${({ theme }) => css`
    display: flex;
    flex-direction: column;
    max-width: 830px;
    min-width: 0;

    @media (max-width: 1300px) {
      max-width: 500px;
    }

    @media (max-width: ${theme.v3.breakpoints.md}) {
      max-width: 100%;
    }
  `}
`;

export const TitleWrapper = styled.p`
  ${({ theme }) => css`
    font-size: ${theme.v3.font.sizes['1xhuge']};
    font-weight: ${theme.v3.font.weights.medium};
    line-height: ${theme.v3.font.lineHeight.spacious};
    color: ${theme.v3.colors.neutral[5]};
    letter-spacing: -0.72px;
    margin: 0;
    margin-bottom: 16px;

    @media (max-width: ${theme.v3.breakpoints.md}) {
      font-size: ${theme.v3.font.sizes.huge};
    }
  `}
`;

export const StarsIcon = styled.span`
  display: inline-flex;
  vertical-align: super;
  margin-left: 4px;
  pointer-events: none;

  svg {
    width: 24px;
    height: 24px;
    @media (max-width: ${({ theme }) => theme.v3.breakpoints.md}) {
      width: 20px;
      height: 20px;
    }
  }
`;

export const TitleGradient = styled.span`
  ${({ theme }) => css`
    position: relative;
    display: inline;
    font-size: ${theme.v3.font.sizes['2xhuge']};
    font-weight: ${theme.v3.font.weights.medium};
    line-height: ${theme.v3.font.lineHeight.spacious};
    letter-spacing: -0.72px;
    background: linear-gradient(
      to right,
      ${theme.v3.colors.brand.snappyOrange[60]},
      color-mix(in srgb, ${theme.v3.colors.accent.pink[60]} 50%, ${theme.v3.colors.brand.snappyOrange[60]})
    );
    -webkit-background-clip: text;
    background-clip: text;
    -webkit-text-fill-color: transparent;

    @media (max-width: ${theme.v3.breakpoints.md}) {
      font-size: ${theme.v3.font.sizes.huge};
    }
  `}
`;

export const Subtitle = styled.p`
  ${({ theme }) => css`
    font-size: ${theme.v3.font.sizes.medium};
    font-weight: ${theme.v3.font.weights.regular};
    color: ${theme.v3.colors.neutral[40]};
    line-height: ${theme.v3.font.lineHeight.comfortable};
    margin: 0;
    margin-bottom: 32px;

    @media (max-width: ${theme.v3.breakpoints.md}) {
      font-size: ${theme.v3.font.sizes.small};
    }
  `}
`;

export const RightSide = styled.div`
  ${({ theme }) => css`
    position: relative;
    flex-shrink: 0;

    &::before {
      content: '';
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      width: 300px;
      height: 170px;
      background: linear-gradient(
        to right,
        ${theme.v3.colors.brand.snappyOrange[60]},
        ${theme.v3.colors.accent.pink[60]}
      );
      border-radius: 50%;
      filter: blur(120px);
      opacity: 0.7;
      z-index: 0;
    }

    @media (max-width: ${theme.v3.breakpoints.md}) {
      width: 100%;
      display: flex;
      justify-content: center;
    }
  `}
`;

export const HeroImage = styled.img`
  position: relative;
  z-index: 1;
  max-width: 473px;
  width: 100%;
  height: auto;
  object-fit: contain;
  border-radius: 20px;

  @media (max-width: 1300px) {
    max-width: 360px;
  }

  @media (max-width: 960px) {
    max-width: 300px;
  }
`;
